var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpowerCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.697,
    cy: 39.3606,
    rx: 1.4578,
    ry: 1.43249,
    transform: "rotate(-90 19.697 39.3606)",
    fill: "#F9B426"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.4133,
    cy: 32.8006,
    rx: 1.4578,
    ry: 1.43249,
    transform: "rotate(-90 20.4133 32.8006)",
    fill: "#F9B426"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.6364,
    cy: 26.6049,
    rx: 1.4578,
    ry: 1.43249,
    transform: "rotate(-90 23.6364 26.6049)",
    fill: "#F9B426"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.2921,
    cy: 22.2315,
    rx: 1.4578,
    ry: 1.43256,
    transform: "rotate(-90 28.2921 22.2315)",
    fill: "#F9B426"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.3804,
    cy: 19.6803,
    rx: 1.4578,
    ry: 1.43256,
    transform: "rotate(-90 34.3804 19.6803)",
    fill: "#F9B426"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1848,
    cy: 19.6803,
    rx: 1.4578,
    ry: 1.43256,
    transform: "rotate(-90 41.1848 19.6803)",
    fill: "#F9B426"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.2729,
    cy: 21.5025,
    rx: 1.4578,
    ry: 1.43249,
    transform: "rotate(-90 47.2729 21.5025)",
    fill: "#F9B426"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.2869,
    cy: 25.876,
    rx: 1.4578,
    ry: 1.43249,
    transform: "rotate(-90 52.2869 25.876)",
    fill: "#F9B426"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.868,
    cy: 31.3428,
    rx: 1.4578,
    ry: 1.43256,
    transform: "rotate(-90 55.868 31.3428)",
    fill: "#F9B426"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.3005,
    cy: 37.9029,
    rx: 1.4578,
    ry: 1.43249,
    transform: "rotate(-90 57.3005 37.9029)",
    fill: "#F9B426"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2261,
    cy: 44.463,
    rx: 1.4578,
    ry: 1.43256,
    transform: "rotate(-90 56.2261 44.463)",
    fill: "#F9B426"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.0032,
    cy: 50.6586,
    rx: 1.45781,
    ry: 1.43249,
    transform: "rotate(-90 53.0032 50.6586)",
    fill: "#F9B426"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.3474,
    cy: 55.0321,
    rx: 1.4578,
    ry: 1.43256,
    transform: "rotate(-90 48.3474 55.0321)",
    fill: "#F9B426"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.2592,
    cy: 57.5832,
    rx: 1.4578,
    ry: 1.43256,
    transform: "rotate(-90 42.2592 57.5832)",
    fill: "#F9B426"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.4548,
    cy: 57.9477,
    rx: 1.4578,
    ry: 1.43256,
    transform: "rotate(-90 35.4548 57.9477)",
    fill: "#F9B426"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.3665,
    cy: 55.3965,
    rx: 1.4578,
    ry: 1.43256,
    transform: "rotate(-90 29.3665 55.3965)",
    fill: "#F9B426"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9946,
    cy: 51.752,
    rx: 1.4578,
    ry: 1.43249,
    transform: "rotate(-90 23.9946 51.752)",
    fill: "#F9B426"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.7713,
    cy: 45.9208,
    rx: 1.4578,
    ry: 1.43256,
    transform: "rotate(-90 20.7713 45.9208)",
    fill: "#F9B426"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.832,
    cy: 35.7161,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 16.832 35.7161)",
    fill: "#F9B426"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.1902,
    cy: 43.3696,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 17.1902 43.3696)",
    fill: "#F9B426"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.0552,
    cy: 50.6586,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 20.0552 50.6586)",
    fill: "#F9B426"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.069,
    cy: 56.4898,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 25.069 56.4898)",
    fill: "#F9B426"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.8734,
    cy: 59.7699,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 31.8734 59.7699)",
    fill: "#F9B426"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.3942,
    cy: 60.8632,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 39.3942 60.8632)",
    fill: "#F9B426"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5569,
    cy: 59.4054,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 46.5569 59.4054)",
    fill: "#F9B426"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.0032,
    cy: 55.0321,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 53.0032 55.0321)",
    fill: "#F9B426"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.3007,
    cy: 48.8364,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 57.3007 48.8364)",
    fill: "#F9B426"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.8075,
    cy: 41.5473,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 59.8075 41.5473)",
    fill: "#F9B426"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.3389,
    cy: 28.4272,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 19.3389 28.4272)",
    fill: "#F9B426"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.6364,
    cy: 22.596,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 23.6364 22.596)",
    fill: "#F9B426"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0828,
    cy: 18.2225,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 30.0828 18.2225)",
    fill: "#F9B426"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.2455,
    cy: 16.4003,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 37.2455 16.4003)",
    fill: "#F9B426"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.7661,
    cy: 17.4936,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 44.7661 17.4936)",
    fill: "#F9B426"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.5704,
    cy: 21.1381,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 51.5704 21.1381)",
    fill: "#F9B426"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.5842,
    cy: 26.9693,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 56.5842 26.9693)",
    fill: "#F9B426"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.0912,
    cy: 33.8939,
    rx: 1.82225,
    ry: 1.79065,
    transform: "rotate(-90 59.0912 33.8939)",
    fill: "#F9B426"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.4297,
    cy: 39.1784,
    rx: 2.00448,
    ry: 1.96967,
    transform: "rotate(-90 13.4297 39.1784)",
    fill: "#F9B426"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.2205,
    cy: 48.2897,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 15.2205 48.2897)",
    fill: "#F9B426"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.876,
    cy: 55.9432,
    rx: 2.00448,
    ry: 1.96967,
    transform: "rotate(-90 19.876 55.9432)",
    fill: "#F9B426"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.6805,
    cy: 61.41,
    rx: 2.00448,
    ry: 1.96967,
    transform: "rotate(-90 26.6805 61.41)",
    fill: "#F9B426"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.9176,
    cy: 63.9611,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 34.9176 63.9611)",
    fill: "#F9B426"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.5127,
    cy: 63.5966,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 43.5127 63.5966)",
    fill: "#F9B426"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.7495,
    cy: 60.3166,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 51.7495 60.3166)",
    fill: "#F9B426"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.8378,
    cy: 54.4854,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 57.8378 54.4854)",
    fill: "#F9B426"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.1354,
    cy: 46.4674,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 62.1354 46.4674)",
    fill: "#F9B426"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.2096,
    cy: 37.7206,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 63.2096 37.7206)",
    fill: "#F9B426"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.504,
    cy: 30.7961,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 14.504 30.7961)",
    fill: "#F9B426"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8018,
    cy: 23.1426,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 18.8018 23.1426)",
    fill: "#F9B426"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.248,
    cy: 16.9469,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 25.248 16.9469)",
    fill: "#F9B426"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1268,
    cy: 13.6668,
    rx: 2.00448,
    ry: 1.96967,
    transform: "rotate(-90 33.1268 13.6668)",
    fill: "#F9B426"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.0801,
    cy: 13.3024,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 42.0801 13.3024)",
    fill: "#F9B426"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.9589,
    cy: 16.2181,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 49.9589 16.2181)",
    fill: "#F9B426"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.1215,
    cy: 21.6849,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 57.1215 21.6849)",
    fill: "#F9B426"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.4191,
    cy: 28.9739,
    rx: 2.00448,
    ry: 1.96973,
    transform: "rotate(-90 61.4191 28.9739)",
    fill: "#F9B426"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.22308,
    cy: 38.6318,
    rx: 3.28006,
    ry: 3.22321,
    transform: "rotate(-90 3.22308 38.6318)",
    fill: "#F9B426"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.46,
    cy: 62.321,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 11.46 62.321)",
    fill: "#F9B426"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.7714,
    cy: 70.339,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 20.7714 70.339)",
    fill: "#F9B426"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.2314,
    cy: 74.3479,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 32.2314 74.3479)",
    fill: "#F9B426"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.37183,
    cy: 51.0231,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 5.37183 51.0231)",
    fill: "#F9B426"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.46,
    cy: 15.6713,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 11.46 15.6713)",
    fill: "#F9B426"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.7714,
    cy: 7.65348,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 20.7714 7.65348)",
    fill: "#F9B426"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.2314,
    cy: 3.28006,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 32.2314 3.28006)",
    fill: "#F9B426"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.7661,
    cy: 3.28006,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 44.7661 3.28006)",
    fill: "#F9B426"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2261,
    cy: 7.28903,
    rx: 3.28006,
    ry: 3.22321,
    transform: "rotate(-90 56.2261 7.28903)",
    fill: "#F9B426"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.5376,
    cy: 15.3069,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 65.5376 15.3069)",
    fill: "#F9B426"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.6256,
    cy: 26.2405,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 71.6256 26.2405)",
    fill: "#F9B426"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.7747,
    cy: 38.6318,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 73.7747 38.6318)",
    fill: "#F9B426"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.6256,
    cy: 51.0231,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 71.6256 51.0231)",
    fill: "#F9B426"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.5376,
    cy: 61.9566,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 65.5376 61.9566)",
    fill: "#F9B426"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2261,
    cy: 69.9745,
    rx: 3.28006,
    ry: 3.22321,
    transform: "rotate(-90 56.2261 69.9745)",
    fill: "#F9B426"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.7661,
    cy: 74.348,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 44.7661 74.348)",
    fill: "#F9B426"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.37183,
    cy: 26.6048,
    rx: 3.28006,
    ry: 3.22314,
    transform: "rotate(-90 5.37183 26.6048)",
    fill: "#F9B426"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.13226,
    cy: 44.2807,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 9.13226 44.2807)",
    fill: "#F9B426"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.7134,
    cy: 53.7565,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 12.7134 53.7565)",
    fill: "#F9B426"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.518,
    cy: 62.5033,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 19.518 62.5033)",
    fill: "#F9B426"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4712,
    cy: 67.6056,
    rx: 2.73338,
    ry: 2.68591,
    transform: "rotate(-90 28.4712 67.6056)",
    fill: "#F9B426"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.4987,
    cy: 69.0634,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 38.4987 69.0634)",
    fill: "#F9B426"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.8845,
    cy: 67.2411,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 48.8845 67.2411)",
    fill: "#F9B426"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.8377,
    cy: 61.7744,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 57.8377 61.7744)",
    fill: "#F9B426"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.2841,
    cy: 53.7565,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 64.2841 53.7565)",
    fill: "#F9B426"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.8655,
    cy: 43.5518,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 67.8655 43.5518)",
    fill: "#F9B426"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.13226,
    cy: 33.7117,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 9.13226 33.7117)",
    fill: "#F9B426"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3554,
    cy: 23.507,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 12.3554 23.507)",
    fill: "#F9B426"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.1599,
    cy: 15.4892,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 19.1599 15.4892)",
    fill: "#F9B426"
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.1132,
    cy: 10.0224,
    rx: 2.73338,
    ry: 2.68591,
    transform: "rotate(-90 28.1132 10.0224)",
    fill: "#F9B426"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.1408,
    cy: 8.20015,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 38.1408 8.20015)",
    fill: "#F9B426"
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5264,
    cy: 10.0224,
    rx: 2.73338,
    ry: 2.68591,
    transform: "rotate(-90 48.5264 10.0224)",
    fill: "#F9B426"
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.4796,
    cy: 15.1247,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 57.4796 15.1247)",
    fill: "#F9B426"
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.2841,
    cy: 23.507,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 64.2841 23.507)",
    fill: "#F9B426"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.8655,
    cy: 32.9827,
    rx: 2.73338,
    ry: 2.68597,
    transform: "rotate(-90 67.8655 32.9827)",
    fill: "#F9B426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerCircle);
export default __webpack_public_path__ + "static/media/empowerCircle.b730db6a3cb351e2baf53a6c7a2d6f4f.svg";
export { ForwardRef as ReactComponent };